import * as Three from 'three';
import React from 'react';

export default {
    name: 'void-circle',
    prototype: 'items',

    info: {
        tag: [''],
        title: 'Void Circle',
        description: 'Void',
        image: require('./void.PNG')
    },

    properties: {
        // altitude: {
        //     label: 'altitude',
        //     type: 'length-measure',
        //     defaultValue: {
        //         length: 0,
        //         unit: 'cm'
        //     }
        // },
        radius: {
            label: 'radius',
            type: 'length-measure',
            defaultValue: {
                length: 30,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let radius = element.properties.get('radius').get('length');
        return (
            <g>
                <circle key='1' cx='0' cy='0' r={radius} style={style} />
                <line key="2" x1={-radius / 1.4} y1={-radius / 1.4} x2={radius / 1.4} y2={radius / 1.4} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                <line key="3" x1={radius / 1.4} y1={-radius / 1.4} x2={-radius / 1.4} y2={radius / 1.4} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    }
};
